"use strict";
var thumbnails = document.querySelector(".gallery__list");
var largeImage = document.querySelector(".gallery__large-img");
thumbnails.addEventListener("click", function(evt) {
    var currentThumbnail = evt.target.closest(".list-item__link");
    if (!currentThumbnail) return;
    evt.preventDefault();
    largeImage.src = currentThumbnail.href;
});

//# sourceMappingURL=index.73b78bae.js.map
